// "A trader asked about your product" — the card the team sends to an
// UNCLAIMED catalogue factory on WhatsApp so it claims its page and answers
// the trader on Maabar (developer handoff of 2026-10-17, item 1).
//
// What the factory sees, and only this (owner, 2026-10-17: «الاسم الأول فقط»):
//   · the trader's FIRST NAME and country — never a surname, company, phone,
//     email or city. The trader's message is the stored text, which was
//     already passed through mask_contact_details() at save.
//   · the product (from the message's product_ref) and the trader's question,
//     in its own language plus a Chinese translation.
//   · the claim link, maabar.io/claim/<claim_slug> — NOT the old
//     /factory-chat share link, which points to a dead 5-Sep thread.
// Nothing here sends anything: the admin downloads, copies or opens
// WhatsApp themselves.

export const CLAIM_BASE = 'https://maabar.io/claim/';

// "Sara Al-Otaibi" -> "Sara". An email-shaped or empty name gives '' — the
// card then just says "a trader from Saudi Arabia".
export function firstName(fullName) {
  const s = String(fullName || '').trim();
  if (!s || s.includes('@')) return '';
  return s.split(/\s+/)[0];
}

// The last thing the trader actually wrote.
export function latestTraderQuestion(thread, trader) {
  const mine = (thread || []).filter((m) => m && m.sender_id === trader && String(m.content || '').trim());
  return mine.length ? String(mine[mine.length - 1].content).trim() : '';
}

// The product the conversation is about — the most recent message that
// carries one.
export function latestProductRef(thread) {
  const withRef = (thread || []).filter((m) => m && m.product_ref && typeof m.product_ref === 'object');
  return withRef.length ? withRef[withRef.length - 1].product_ref : null;
}

export function claimUrl(slug) {
  const s = String(slug || '').trim();
  return s ? `${CLAIM_BASE}${encodeURIComponent(s)}` : '';
}

// wa.me takes the number as bare digits, no '+'.
export function waLink(e164, text) {
  const digits = String(e164 || '').replace(/\D/g, '');
  if (!digits) return '';
  return `https://wa.me/${digits}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
}

const hasHan = (s) => /[一-鿿]/.test(String(s || ''));

// The product's name as the factory will recognise it: Chinese when the
// catalogue has it (rare — 1 product on 2026-10-17), else English, else Arabic.
export function productName(ref, nameZh) {
  return String(nameZh || ref?.name_en || ref?.name_ar || '').trim();
}

// Everything the card and the WhatsApp message say, in one place so the PNG
// and the copied text can never disagree.
export function cardContent({ fullName, question, questionZh, ref, nameZh, claimSlug }) {
  const first = firstName(fullName);
  const product = productName(ref, nameZh);
  const price = String(ref?.price || '').trim();
  const q = String(question || '').trim();
  const zh = hasHan(q) ? '' : String(questionZh || '').trim();
  const link = claimUrl(claimSlug);
  return {
    first,
    headline: '一位来自沙特阿拉伯的采购商询问了您的产品',
    buyerLine: first ? `采购商：${first}（沙特阿拉伯）` : '采购商：来自沙特阿拉伯',
    product,
    price,
    image: ref?.image || '',
    question: q,
    questionZh: zh,
    link,
    cta: '认领您的工厂页面，即可在 Maabar 直接回复这位采购商：',
    note: '注册时请使用我们记录中的贵公司手机号或邮箱，其他号码或邮箱无法完成认领。',
  };
}

// The text copied to the clipboard and pre-filled in WhatsApp.
export function cardMessage(c) {
  const lines = [
    '您好！我们是 Maabar（maabar.io）——连接沙特阿拉伯采购商与中国工厂的 B2B 平台。',
    '',
    `${c.first ? `一位来自沙特阿拉伯的采购商（${c.first}）` : '一位来自沙特阿拉伯的采购商'}在 Maabar 上询问了您的产品：${c.product}${c.price ? `（${c.price}）` : ''}`,
  ];
  if (c.question) lines.push('', `采购商的问题：${c.question}`);
  if (c.questionZh) lines.push(`中文翻译：${c.questionZh}`);
  if (c.link) lines.push('', `${c.cta}${c.link}`, c.note);
  return lines.join('\n');
}
